export const tableColumnList = [
  {
    field: 'propertyType', // 1
    title: '资产类型',
    width: '150',
    editRender: {
      name: 'propertyType',
    },
  },

  {
    field: 'sumArea',
    title: '总面积(平方米)',
    width: '170',
    editRender: { name: 'sumArea' },
  },

  {
    field: 'leasedArea',
    title: '已出租面积(平方米)',
    width: '170',
    editRender: { name: 'leasedArea' },
  },

  {
    field: 'unleasedArea',
    title: '未出租面积(平方米)',
    width: '170',
    editRender: {
      name: 'unleasedArea',
    },
  },
  {
    field: 'selfUsedArea',
    title: '自用面积(平方米)',
    width: '170',
    editRender: {
      name: 'selfUsedArea',
    },
  },
  {
    field: 'revenue',
    title: '本月收入(万元)',
    width: '170',
    editRender: {
      name: 'revenue',
    },
  },
  {
    field: 'rentPriceRange',
    title: '单价区间(元/㎡)',
    width: '170',
    editRender: { name: 'rentPriceRange' },
  },

  {
    field: 'remark',
    title: '备注',
    width: '190',
    editRender: { name: 'remark' },
  },
];

export const tableRules = {
  // propertyType: [{ required: true, message: '资产类型不能为空' }],
  // leasedArea: [{ required: true, message: '已出租面积不能为空' }],
  // unleasedArea: [{ required: true, message: '未出租面积不能为空' }],
  // selfUsedArea: [{ required: true, message: '自用面积不能为空' }],
  // revenue: [{ required: true, message: '本月收入不能为空' }],
  // rentPriceRange: [{ required: true, message: '单价区间不能为空' }],
};
